// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import './style.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


class StoryTeller extends React.Component {
    constructor(props) {
      super(props);
      this.state = {};
    }
    render() { 
        return (
            <div>
            <section className="story-telling">
                <div className="container">
                    <div className="story-head">
                        <h1>{this.props.StoryHead}</h1>
                        <p>{this.props.StorySubHead}</p>
                    </div>
                    <Row className="storyteller-pad50">
                        <Col sm={12} md={12} lg={4}>
                            <div className="bg-color-grey">
                                <div className="story-pic-grid">
                                    <img alt="hostImage" src={this.props.hostImage} className="story-img img-fluid" />
                                </div>
                                {this.props.imageStatus !== false ?
                                <div className="storyteller-data">
                                    <h2>{this.props.UploadData}</h2>
                                    <p>{this.props.UploadDataDescription}</p>
                                </div>
                                :
                                <div className="storyteller-data">
                                    <p className="participateText"><span>{this.props.eventName}</span> {this.props.UploadDataDescription}</p>
                                </div>
                                }
                            </div>
                        </Col>
                        <Col sm={12} md={12} lg={4}>
                            <div className="bg-color-grey">
                                <div className="story-pic-grid">
                                    <img alt="hostImage" src={this.props.recordImage} className="story-img img-fluid" />
                                </div>
                                {this.props.imageStatus !== false ?
                                <div className="storyteller-data">
                                    <h2>{this.props.RecordData}</h2>
                                    <p>{this.props.RecordDataDescription}</p>
                                </div>
                                 :
                                 <div className="storyteller-data">
                                     <p className="participateText"><span>{this.props.recordName}</span> {this.props.UploadDataDescription}</p>
                                 </div>
                                 }
                            </div>
                        </Col>
                        <Col sm={12} md={12} lg={4}>
                            <div className="bg-color-grey">
                                <div className="story-pic-grid">
                                    <img alt="presentationImage" src={this.props.presentationImage} className="story-img img-fluid" />
                                </div>
                                {this.props.imageStatus !== false ?
                                <div className="storyteller-data">
                                    <h2>{this.props.AccessData}</h2>
                                    <p>{this.props.AccessDataDescription}</p>
                                </div>
                                 :
                                 <div className="storyteller-data">
                                     <p className="participateText"><span>{this.props.attendName}</span> {this.props.UploadDataDescription}</p>
                                 </div>
                                 }
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
            </div>
            );
        }
      }
      
      
      export default StoryTeller;